module.exports = {
    MAP_X_COORDINATE: 'defaultMapXCoordinate',
    MAP_Y_COORDINATE: 'defaultMapYCoordinate',
    MAP_ZOOM: 'defaultMapZoom',
}
